/** Preserve the existing project deadline; transport and cancellation stay in core. */
export const API_CONFIG = {
  timeoutMs: 15_000,
  productVariantImages: undefined as boolean | undefined,
  stableCategoryDetails: false,
};
